<template>
  <div>
    <div class="border-around">
      <!-- <vs-row class="p-5">
        <vs-col>
          <h6>Blocks</h6>
          <vs-row class="mt-2">
            <vs-button class="mr-3" v-on:click="saveDesign">Save Design</vs-button>
            <vs-button class="mr-3" v-on:click="exportHtml">Export HTML</vs-button>
          </vs-row>
        </vs-col>
      </vs-row> -->

      <vs-row>
        <EmailEditor
          ref="emailEditor"
          v-on:load="editorLoaded"
          v-on:ready="editorReady"
          min-height="800px"
          :options="options"
          :tools="tools"
          :projectId="projectId"
        />
      </vs-row>
    </div>
  </div>
</template>

<script>
import { EmailEditor } from "capacit-vue-dynamic-editor";
import venueMasterTemplate from "./UnlayerMasterTemplates/venue_template.json";

export default {
  components: {
    EmailEditor,
  },
  props: ["emailJson", "venueLogoUrl"],
  data() {
    let logoUrl =
      "https://rekomlifestorageprod.blob.core.windows.net/crm/venue_logo_square_placeholder.svg";

    if (this.venueLogoUrl) {
      logoUrl = this.venueLogoUrl;
    }

    return {
      venueInfo: {
        logoUrl,
      },
      venueMasterTemplate,
      appearance: {
        theme: "dark",
      },
      projectId: 61960,
      options: {
        features: {
          textEditor: {
            tables: true,
          },
          preview: false,
        },
        customJS: [
          "https://rekomlifestorageprod.blob.core.windows.net/crm/unlayer_customjs.js",
        ],
      },
      tools: {
        "custom#venue_logo": {
          position: 0,
          values: {
            logoUrl: logoUrl,
          },
        },
      },
    };
  },
  methods: {
    applySpecialLinks() {
      const specialLinks = this.$store.getters["handlebars/getFor"](
        "venueGuest"
      ).map((e) => {
        return {
          name: e.name,
          href: `{{${e.handlebar}}}`,
          target: "_blank",
        };
      });

      this.$refs.emailEditor.editor.setSpecialLinks(specialLinks);
    },
    applyMergeTags() {
      const guestTags = {};
      const venueTags = {};
      const sendTags = {};
      const bookingTags = {};
      this.$store.getters["handlebars/getFor"]("guest").forEach((e) => {
        guestTags[e.handlebar] = {
          name: e.name,
          value: `{{${e.handlebar}}}`,
          sample: e.sample,
        };
      });
      this.$store.getters["handlebars/getFor"]("venue").forEach((e) => {
        venueTags[e.handlebar] = {
          name: e.name,
          value: `{{${e.handlebar}}}`,
          sample: e.sample,
        };
      });
      this.$store.getters["handlebars/getFor"]("sendDate").forEach((e) => {
        sendTags[e.handlebar] = {
          name: e.name,
          value: `{{${e.handlebar}}}`,
          sample: e.sample,
        };
      });
      this.$store.getters["handlebars/getFor"]("venueGuest").forEach((e) => {
        venueTags[e.handlebar] = {
          name: e.name,
          value: `{{${e.handlebar}}}`,
          sample: e.sample,
        };
      });
      this.$store.getters["handlebars/getFor"]("booking").forEach((e) => {
        bookingTags[e.handlebar] = {
          name: e.name,
          value: `{{${e.handlebar}}}`,
          sample: e.sample,
        };
      });

      const tags = {
        guest: {
          name: "Guest",
          mergeTags: guestTags,
        },
        venue: {
          name: "Venue",
          mergeTags: venueTags,
        },
        send: {
          name: "Send information",
          mergeTags: sendTags,
        },
        booking: {
          name: "Booking",
          mergeTags: bookingTags,
        },
      };

      this.$refs.emailEditor.editor.setMergeTags(tags);
    },

    onSelectImage(data, done) {
      console.log("OnSelectImage");
      console.log(data, done);
    },
    editorLoaded() {
      const baseTemplate = this.emailJson ? JSON.parse(this.emailJson) : ""; //this.venueMasterTemplate;

      if (baseTemplate != "") this.$refs.emailEditor.loadDesign(baseTemplate);
      // TODO custom image selector
      // this.$refs.emailEditor.editor.registerCallback("selectImage", this.onSelectImage);

      console.log("LOADED", baseTemplate);

      console.log("Applying special links and merge tags");
      this.applySpecialLinks();
      this.applyMergeTags();
    },
    // called when the editor has finished loading
    editorReady() {
      console.log("editorReady", this.$refs.emailEditor.editor); // Editor is not always called
    },
    async saveDesign() {
      return new Promise((resolve) => {
        this.$refs.emailEditor.editor.saveDesign((design) => {
          console.log("saveDesign", design);
          resolve(design);
        });
      });
    },
    async export() {
      return new Promise((resolve) => {
        this.$refs.emailEditor.editor.exportHtml((exportData) => {
          console.log("exportHtml", exportData);
          resolve(exportData);
        });
      });
    },
  },
};
</script>

<style lang="scss">
.unlayer-editor {
  min-width: 100%;
}

.border-around {
  border: 1px #999 solid;
}
</style>